/**
 * @file 开始使用页入口
 * @author wanzhongyun
 */

import React from 'react';

import Header from '../../components/header/HeaderWithStore';
import QuickPane from './pages/quick/Quick';
import Footer from '../../components/footer/Footer';

const Install: React.FC = () => {

    return (
        <div className="page paddle-install-page">
            <Header />
            <div className="paddle-install-page-container">
                <QuickPane />
            </div>
            <Footer />
        </div>
    );
};

export default Install;
